import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  Input,
  inject,
} from "@angular/core";
import { IconName } from "@fortawesome/free-brands-svg-icons";
import { CommonModule } from "@angular/common";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { TypeFooterFields } from "../../../models/contentful-content-types/section-footer";
import {
  Router,
  RouterModule,
  UrlSegment,
  UrlSegmentGroup,
  UrlTree,
} from "@angular/router";
import { ScrollAnchorDirective } from "../../utils/directives/scroll-anchor.directive";
@Component({
  imports: [CommonModule, FontAwesomeModule, RouterModule, ScrollAnchorDirective],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  selector: "jnguyen-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.scss"],
})
export class FooterComponent {
  @Input() data: TypeFooterFields;
  private readonly router = inject(Router);

  getIcon(icon: IconName, iconClass: string): string[] {
    return [iconClass, icon];
  }

  private buildPopupUrlTree(segments: string[]): UrlTree {
    const tree = this.router.parseUrl(this.router.url);
    tree.root.children["popup"] = new UrlSegmentGroup(
      segments.map((s) => new UrlSegment(s, {})),
      {}
    );
    return tree;
  }

  private parsePopup(url: string | undefined): string[] | null {
    if (!url) return null;
    const re = /^popup:(.+)$/i;
    const m = re.exec(url);
    if (!m) return null;
    const segs = m[1]
      .split("/")
      .map((s) => s.trim())
      .filter(Boolean);
    return segs.length ? segs : null;
  }

  isExternalLink(url: string | undefined): boolean {
    if (!url) return false;
    return /^(https?:|mailto:|tel:|\/\/)/i.test(url);
  }

  routerLinkTarget(url: string | undefined): string | UrlTree | null {
    if (!url) return null;
    const popupSegs = this.parsePopup(url);
    if (popupSegs) return this.buildPopupUrlTree(popupSegs);
    return url;
  }
}
